export const JERONIMO_EMAIL = 'jmp.planowanierozwoju@jeronimo-martins.com';
export const KNOWME_EMAIL = 'knowme-jm@bluesoft.com';
